import React from "react";
import { withRouter } from "react-router";
import { DATE_FORMAT, PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw"; 
import GridFw, { COLUMN_DEFAULT } from "../../../../../framework/grid/GridFw";
import { S3Util } from "../../../../../util/S3Util"; 
import { BasePage } from "../../../../../framework/pages/BasePage";
import { MessageUtil } from '../../../../../util/MessageUtil';
import { UserUtil } from "../../../../../util/UserUtil";
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { EnvConstants } from '../../../../../EnvConstants';
import { LoadingUtil } from "../../../../../util/LoadingUtil";
import { ReportUtil } from "../../../../../util/ReportUtil";

class PagoServicioSection extends BasePage {
    renderPage(pageApi) {
       
    const getFormDatosEmision = () => pageApi.getComponent('formDatosEmision'); 
    const getFormS3 = () => pageApi.getComponent("formS3");
    const getGrid4 = () => pageApi.getComponent("grid4");
 
    const calcularPagoServicio = () => {
        let total = 0;
        let items = getGrid4().getData();
          if (items) { 
       
          items.forEach((item) => {
          total =
          total +
          (isNaN(parseFloat(item.monto_abonado)) ? 0 : parseFloat(item.monto_abonado));
          }); 
          }

          let Total_Pagar = getFormDatosEmision()?.getData().total_pagar;       
          let aplica_comprobante = getFormDatosEmision()?.getData().aplica_comprobante;       
          
          if(aplica_comprobante == 1) {
            if (total > Total_Pagar) {
                return MessageUtil(
                  "warning",
                  "Alerta!",
                  "El Monto Abonado es mayor al Total a Pagar" 
                ); 
            } 
            else if (total < Total_Pagar) { 
              return MessageUtil(
                "warning",
                "Alerta!",
                "El Monto Abonado es menor al Total a Pagar" 
              ); 
            }
          } 
    }

    const DescargarPDFCotizacion = (params, nomArchivo) => {
      const url = EnvConstants.GET_REPORT2_URL() + "CotizacionMa";     
      const archivo = `Cotizacion_${nomArchivo}`;

      LoadingUtil.loadShow();
      ReportUtil.donwloadFromPost(url, params, archivo)
      .then(() => LoadingUtil.loadHide())
      .catch(x => {
          console.error(x)
          LoadingUtil.loadHide();
      });
    }
 
    const formDatosEmision = {
      layout: 'vertical', 
     load:{
      validation: () => pageApi.getParamId() != null, 
      queryId: 838,
      params: {id_doc: pageApi.getParamId()}, 
      hideMessage: true, 
      hideMessageError: true
      },
      save: {
        queryId: 841,
        postLink: (resp, values) => '/cotizaciones/cotizaciones-admin',
        params: { id_doc: pageApi.getParamId(),id_user: UserUtil.getUserId()},
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => { 
          const params = { queryId: 860, params: { id_doc: pageApi.getParamId() } };
          const nomArchivo = `Aprobada_${resp.dataObject.doc_nro}.pdf`;
          DescargarPDFCotizacion(params, nomArchivo);

          return MessageUtil(
            "success",
            "Exito!",
            "Se actualizó correctamente"
          ); 
        },
      },  
      title: '', 
      fields:[
          {
              label: '  ',
              fields: [
                  {type: 'hidden', name: 'id_doc_cotizacion'},
                  {name: "simb_moneda", label: "Total a Pagar", column: 4, readOnly: true}, 
                  {type: 'select', name:'Tipo_comprobante', label:'Tipo Comprobante a emitir', column: 3, value: 2,
                    load: {
                        dataList: [
                            {label: 'Boleta', value: 1},
                            {label: 'Factura', value: 2}
                        ]
                    }, 
                  }, 
              ]
          }
      ],  
      onComponentLoad : (formApi, pageApi) =>{
          if (pageApi.getPageMode() !== PAGE_MODE.NEW)
              formApi.load();
      } 
    }
 
    const formS3 = {
      title: "Registro de Abono",
      fields: [
        {
          type: "dragger",
          name: "archivo",
          label: "Arrastra y suelta tus archivos",
          multiple: 4,  
          folder: "bvdigital-repository-ma-per-pr/cotizaciones/cotizaciones-admin",
          //folder: 'test1fw/fw2',
          onChange: (value, values) => {
            //funcion asincrona para retornar el url del blob
            async function getUrl(file_name, ruta) {
              let result = await S3Util.getUrlS3(file_name, ruta);
              return result;
            }

            let lst = getFormS3().getFieldApi("archivo").getFileList();
            //console.log(getForm().getFieldApi('archivo').getFileList());
            if (value && value.length > 0) {
              lst.forEach((file) => {
                getUrl(
                  file.fileId, 
                  "bvdigital-repository-ma-per-pr/cotizaciones/cotizaciones-admin" 
                ).then((urlComplete) => {
                  var text = urlComplete.split("?");
                  var url = text[0];
                  getGrid4().addItem(
                    {
                      FILENAME: file.fileId,
                      originalName: file.name,
                      TYPE_FILE: file.type,
                      PATH_FILE: 
                        "bvdigital-repository-ma-per-pr/cotizaciones/cotizaciones-admin",
                      URL: url,
                      monto_abonado:0
                    },
                    true
                  );
                });
              });
            }
            getFormS3().reset();
          },
          column: 12,
        },
      ],
    };

    const gridConfig4 = {
      collapsible: true,
      showIndex: true,
      autoLoad: true,
      rowId: "ID_FILE",
      pagination: {
        server: true,
      },
      load: {
        queryId: 836,
        params: { id_doc: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      addItem: {
        fnAfter: (row) => {
            // calcularPagoServicio();
        }
      },
      updateItem: {
        fnAfter: (row) => { 
            calcularPagoServicio();
        }
      },
       save: {
       queryId: 839,
       params: { 
          id_doc: pageApi.getParamId(), 
           id_user: UserUtil.getUserId(), 
         },
       hideMessage: true,
       hideMessageError: true,
       fnOk: (resp) => {    
       }, 
      },
      fields: [
        { name: "FILENAME", label: "Archivo" },
        { name: "nro_operacion", label: "Numero de Operacion", editable: true }, 
        {
          type: "date",
          name: "fecha_emision",
          label: "Fecha Emision",   
          editable:true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
        type: "number",
        name: "monto_abonado",
        label: "Monto Abonado",
        editable: true,        
          onclick: (value, values, formApi) => {   
                //  let monto_abonado = parseInt(values["monto_abonado"]);
                //  let monto_abonado = values["monto_abonado"];
                //   formApi?.setFieldData("monto_abonado", monto_abonado);

                    formApi.values.monto_abonado = value;
             getGrid4().refresh()
         },
      },  
        {
          ...COLUMN_DEFAULT.VIEW,
          onClick: (value, row, index) => {
            S3Util.donwload(
              row.FILENAME, 
              "bvdigital-repository-ma-per-pr/cotizaciones/cotizaciones-admin" 
            );
          },
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          process: {
            fnOk: (resp) => getGrid4().load(),
            filter: (value, row, index) => ({
              queryId: 840, 
              params: { ID: row.ID_FILE },
            }),
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const barButtonFooter = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN,label: 'Retornar al Inicio', link: '/cotizaciones/cotizaciones-admin', alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE,label: 'Finalizar Compra', onClick: () => { 
                let total = 0;
                let items = getGrid4().getData();
                if (items) {  
                items.forEach((item) => {
                total =
                total +
                (isNaN(parseFloat(item.monto_abonado)) ? 0 : parseFloat(item.monto_abonado));
                }); 
                }

                let Total_Pagar = getFormDatosEmision()?.getData().total_pagar;       
                let aplica_comprobante = getFormDatosEmision()?.getData().aplica_comprobante;       

                if(aplica_comprobante == 1) {
                  if (total > Total_Pagar) {
                    return MessageUtil(
                    "warning",
                    "Alerta!",
                    "El Monto Abonado es mayor al Total a Pagar" 
                    ); 
                  } 
                  else if (total < Total_Pagar) { 
                    return MessageUtil(
                    "warning",
                    "Alerta!",
                    "El Monto Abonado es menor al Total a Pagar" 
                    ); 
                  } 
                  else { 
                  getGrid4().save();
                  getFormDatosEmision().save(); 
                  }
                }
                else { 
                  getGrid4().save();
                  getFormDatosEmision().save(); 
                }

              } 
            
            }, 
        ]
    }


    return (
      <>
        <FormFw
          name="formDatosEmision"
          getParentApi={pageApi.getApi}
          config={formDatosEmision} 
        />
 
        <FormFw name="formS3" getParentApi={pageApi.getApi} config={formS3} />
        <GridFw
          name="grid4"
          getParentApi={pageApi.getApi}
          config={gridConfig4}
        />

        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter} 
        />
      </>
    ); 
}
}

export default PagoServicioSection